import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel, UIComponentState } from '../uicomponent';
import * as React from 'react';
import { MessageComponentProps, MessageComponentHandler } from './messagecomponent';
import { MessageCSSStyle } from './messagecss';

export class MessageViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    }
    
    draw(props: MessageComponentProps, state: UIComponentState, cssStyle: MessageCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            
                <div>
                    {props.messageContent}
                </div>
            
        );
    }

     onCloseButtonClick(e:React.MouseEvent):void
     {
        (this.getUIComponentHandler() as MessageComponentHandler).onCloseButtonClicked(e);
     }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/messagecomponent/messageview.tsx